import { useTheme } from 'styled-components';
import { CTAIconPosition, CTATag } from '../../atoms/CTA/CTA.constants';
import { HeroContainer } from '../Hero/Hero.styles';
import Headline from '../../atoms/Headline/Headline';
import HeroBackground from '../Hero/Hero.Background';
import SafeHTML from '../../atoms/SafeHTML';
import { GradientOverlay } from './TeaserFullWidth.styles';
import * as S from './TeaserFullWidth.styles';

/**
 * @param {TeaserFullWidthContent} props
 * @returns {React.ReactElement}
 */

const TeaserFullWidthContent = ({
  id,
  headline,
  text,
  orientation,
  links,
  ctaStyle,
}) => (
  <S.StyledContainerGrid direction={orientation}>
    <Headline level={headline?.level || 3}>{headline?.text || ''}</Headline>
    <SafeHTML html={text} />
    <S.StyledLinksWrapper direction={orientation}>
      {links &&
        links.map((link) => (
          <S.CTAStyled
            key={`${id}-${link.url}`}
            skin={ctaStyle || 'PRIMARY'}
            title={link.text}
            text={link.text}
            type={CTATag.Link}
            icon="ARROW_ANIMATION"
            iconPos={CTAIconPosition.After}
            href={link.url}
            target={link.target}
          />
        ))}
    </S.StyledLinksWrapper>
  </S.StyledContainerGrid>
);

/**
 * @param {TeaserFullWidthProps} props
 * @returns {React.ReactElement}
 */

const TeaserFullWidth = ({
  id,
  headline,
  text,
  gradient,
  image,
  smallImage,
  links,
  orientation,
}) => {
  const theme = useTheme();
  return (
    <HeroContainer
      key={id}
      headerHeight={0}
      pageType={'career'}
      teaserFullWidth
      fullWidth
    >
      {(smallImage || image) && (
        <HeroBackground
          mobileImage={smallImage}
          background={image}
          grayscale={!!gradient}
          heroEVP
          teaserFullWidth
          context="TEASER_FULL_WIDTH"
        />
      )}
      {gradient && <GradientOverlay gradient={gradient} />}
      {(headline || text) && (
        <TeaserFullWidthContent
          id={id}
          text={text || ''}
          headline={headline || ''}
          orientation={orientation}
          links={links}
          ctaStyle={theme?.teaserFullWidth?.ctaStyle}
        />
      )}
    </HeroContainer>
  );
};

export default TeaserFullWidth;
